module.exports = __webpack_public_path__ + "83a03c0d2e772555bf12e5df1de507e6.svg";